import sanctum from '../http/requests/auth/sanctum';
import * as permissions from '../const/permissions';

export default (user = sanctum.getUser() || null) => {
  if (!user) return null;
  const userPermissions = {
    canCreateSuratMasuk: permissions.canCreateSuratMasuk(user.role),
    canParallelDisposition: permissions.canParallelDisposition(user.role),
    canParafDisposition: permissions.canParafDisposition(user.role),
    canPengajuanDisposition: permissions.canPengajuanDisposition(user.role),
    isHeadPosition: permissions.isHeadPosition(user.role),
    canCreateSuratKeluar: permissions.canCreateSuratKeluar(user.role),
  };
  return {
    ...user,
    ...userPermissions,
  };
};
